import { styled } from '../../../core/theme/styled';

export const Container = styled.button<{ selected?: boolean }>`
  width: 100%;
  text-align: left;
  font-size: ${(props) => props.theme.sizes.normal};
  font-family: ${(props) => props.theme.font.face};
  padding: ${(props) => props.theme.sizes.small} ${(props) => props.theme.sizes.normal};
  margin-bottom: ${(props) => props.theme.sizes.normal};
  border-radius: ${(props) => props.theme.roundedCorners.xsmall};
  line-height: 1.5;

  border: 1px solid
    ${(props) => (props.selected ? 'transparent' : props.theme.configuration.strokeColor)};
  color: ${(props) =>
    props.selected
      ? props.theme.configuration.buttonTextColor
      : props.theme.configuration.primaryTextColor};
  background-color: ${(props) =>
    props.selected
      ? props.theme.configuration.buttonBackgroundColor
      : props.theme.configuration.backgroundColor};
  box-shadow: ${(props) => (props.selected ? props.theme.shadows.large : 'none')};
  transition: box-shadow 0.2s ease-in-out;
  &:hover {
    box-shadow: ${(props) => props.theme.shadows.small};
    cursor: pointer;
  }
`;
